import React from 'react';
function MoonIcon(){
    return(
        <svg width="15" height="22" viewBox="0 0 15 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 11C1 16.5228 5.37719 21 10.7767 21C11.9061 21 12.9908 20.8041 14 20.4438C10.1841 19.0813 7.44653 15.3677 7.44653 11C7.44653 6.63233 10.1841 2.91865 14 1.55621C12.9908 1.19587 11.9061 1 10.7767 1C5.37719 1 1 5.47715 1 11Z" stroke="black" strokeWidth="1.3" strokeLinejoin="round" />
        </svg>
    )
}

export default MoonIcon;
